<template>
    <div class="Source">
        <Header msg="推广海报库"/>
        <div class="padding-style">
          <div class='overflow-company-second'>
            <div class="special-list">
              <div class="card-item" v-for="(item, index) in catList" :key="`cat${index}`" @click="changeCat(index)">
                <p>{{item.name}}</p>
                <div :class="catIndex == index ? 'item-line':''"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="SourceBox flex flex-j-c-center" v-if="!shownull" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading">
            <div class="Source-card flex flex-j-c-sb" v-for="(e, i) in SourceData" :key="`${i}fi`" @click="toPoster(e)">
              <img v-lazy="{src:e.bill_pic, loading:require('@/assets/loading.gif'), error:require('@/assets/error.jpg')}" class="card-img"/>
              <div class="card-box">
                  <p class="card-title ellipsis">{{e.name}}</p>
                  <p class="card-btn">查看详情</p>
              </div>
            </div>
            <div class="Source-card Source-none" v-for="(e, i) in 2" :key="`${i}se`"></div>
        </div>
        
        <Nomore v-if="showNoMore"/>
        <DataNull v-if="shownull"/>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import DataNull from '@/components/DataNull';
import Nomore from '@/components/Nomore';
import Navbar from '@/components/Navbar.vue';
import { getSource } from '@/api';

export default {
    name: 'Source',
    components: {
      Header,
      DataNull,
      Nomore,
      Navbar
    },
    data() {
      return {
        SourceData: [], // 页面列表数据
        shownull: false,
        loading: true,
        page: 1, // 页数
        showNoMore: false,
        cat_id: 0, // 分类id
        catList: [], // 各分类列表数据
        catIndex: 0, // 分类索引
      }
    },
    watch:{
    },
    created() {
      this.getSources('init');
    },
    mounted() {
    },
    methods: {
      // 改变分类
      changeCat(index) {
        if (index === this.catIndex) {
          return false;
        }
        this.SourceData = [];
        this.page = 1;
        this.cat_id = Number(this.catList[index].id);
        this.getSources();
        this.catIndex = index;
      },
      //到底加载
      loadMore(){
        if (this.loading) return false;
        this.loading = true
        this.page += 1;
        this.getSources();
      },
      // 获取素材接口
      getSources(type) {
        getSource({page: this.page, limit: 10, cat_id: this.cat_id}).then(res => {
          if (res.code === 0) {
            this.SourceData = this.SourceData.concat(res.data);
            this.catList = res.cat;
            this.catList.unshift({id: "0", name: "全部"})
            if (res.data.length === 0) { this.shownull = true } else {this.shownull = false};
            if (res.data.length === 10) { this.loading = false; };
            if (res.data.length !== 10 && res.data.length !== 0) { this.showNoMore = true };
            if (Number(res.totalCount) === this.SourceData.length) { this.loading = true;this.showNoMore = true };
            // if (type === 'init') this.init();
          } else {
            this.shownull = true;
            this.showNoMore = false;
          }
        })
      },
      // 跳转海报详情
      toPoster(e) {
        this.$router.push({name:'Poster', query:{playbill_id: e.id}})
      },
      // 初始化
      init() {
        var arr = [];
        for( var i = 0;i < this.SourceData.length; i++ ){
          var c = {id:i, src:this.SourceData[i].bill_pic, crossOrigin: '*'};
          arr.push(c);
        }
        // console.log(arr)
        const creLoad = this.mywindow.createjs;
        var queue = new creLoad.LoadQueue();
        //监听事件
        queue.on('progress',function(e){
          //获取 百分比
          var p = Math.floor(e.progress * 100);
          console.log(p)
          // $('#ld_loading').html('LOADING... '+p+'%');
        },this)
        //监听完成
        queue.on('complete',function(e){
          console.log('All-Images-Ready!');
        },this);
        //加载资源
        queue.loadManifest(arr);
      }
    }
}

</script>
<style lang='less' scoped>
image[lazy=loading] {
  width: 100%;
  height: 100%;
}
.padding-style{
  padding-left: 0.06rem;
  // margin-top: 0.44rem;
  margin-bottom: 0.1rem;
  position: fixed;
  top: 0.44rem;
  width: 100%;
  background: #F6F6FA;
}
.overflow-company-second{
  overflow: hidden;
  height: 0.5rem;
}
.special-list{
    line-height: 0.5rem;
    display: flex;
    overflow-x: auto;
    justify-content: space-between;
}
.special-list>.card-item{
  text-align: center;
  color: #283B42;
  font-size: 0.15rem;
  font-weight: bold;
  flex-basis: 0.7rem;
  flex-shrink: 0;
  white-space: nowrap;
  margin: 0 0.1rem;
  p{
    z-index: 2; 
  }
}
.item-line{
    width: 100%;
    height: 0.05rem;
    color: #333333;
    background: goldenrod;
    border-radius: 0.025rem;
    margin-top: -0.22rem;
    -webkit-animation: navShow 0.3s;
    animation: navShow 0.3s;
}
.Source{
    min-height: 100vh;
    .SourceBox{
        border-top: 0.94rem solid #F6F6FA;
        width: 100%;
        // min-height: 100vh;
        height: auto;
        flex-wrap: wrap;
        .Source-card{
            width: 1.67rem;
            height: 2.15rem;
            flex-direction: column;
            border-radius: 6px;
            background: white;
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
            margin: 0 0.05rem 0.13rem;
            .card-img{
                width: 100%;
                height: 1.58rem;
                border-radius: 6px 6px 0 0;
            }
            
            .card-box{
                padding: 0.1rem 0.08rem;
                p{
                    line-height: 0.2rem;
                    width: 100%;
                }
                .card-title{
                    font-size: 0.14rem;
                    color: #000000;
                    text-align: left;
                }
                .card-btn{
                    font-size: 0.12rem;
                    text-align: right;
                    color: #FABD01;
                }
            }
        }
        .Source-none{
            height: 0;
        }
    }
}
</style>